// src/modules/auth/Login.tsx - Компонент логина
import React from 'react';
import { Form, Input, Button, Card, message, Typography } from 'antd';
import { UserOutlined, LockOutlined, CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const { Title } = Typography;

interface LoginForm {
  username: string;
  password: string;
}

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading } = useAuth();
  const [form] = Form.useForm();

  const onFinish = async (values: LoginForm) => {
    try {
      await login(values.username, values.password);
      message.success('Успешный вход в систему');
      navigate('/dashboard');
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 
                          error.response?.data?.error?.message || 
                          'Ошибка авторизации';
      message.error(errorMessage);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f0f2f5',
      padding: '20px'
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>
        <Card 
          title={
            <div style={{ textAlign: 'center' }}>
              <CrownOutlined style={{ fontSize: '24px', marginRight: '8px', color: '#1890ff' }} />
              <Title level={3} style={{ margin: 0, display: 'inline' }}>
                DomChef Admin
              </Title>
            </div>
          }
        >
          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
            size="large"
          >
            <Form.Item
              label="Имя пользователя"
              name="username"
              rules={[{ required: true, message: 'Введите имя пользователя' }]}
            >
              <Input 
                prefix={<UserOutlined />} 
                placeholder="Имя пользователя" 
              />
            </Form.Item>

            <Form.Item
              label="Пароль"
              name="password"
              rules={[{ required: true, message: 'Введите пароль' }]}
            >
              <Input.Password 
                prefix={<LockOutlined />} 
                placeholder="Пароль" 
              />
            </Form.Item>

            <Form.Item>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={isLoading}
                block
              >
                Войти
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};